import React from "react";
import { motion } from "framer-motion";
import css from "../assets/experience/css.png";
import express from "../assets/experience/express.png";
import firebase from "../assets/experience/firebase.png";
import html from "../assets/experience/html.png";
import javascript from "../assets/experience/javascript.png";
import nextjs from "../assets/experience/nextjs.png";
import node from "../assets/experience/node.png";
import react from "../assets/experience/react.png";
import tailwind from "../assets/experience/tailwind.png";

const capabilityGroups = [
  {
    title: "Frontend systems",
    items: [
      "React",
      "Next.js",
      "React Native",
      "Expo",
      "Tailwind CSS",
      "Responsive UI",
      "Motion",
    ],
  },
  {
    title: "Backend foundations",
    items: [
      "Node.js",
      "Express",
      "AWS",
      "PostgreSQL",
      "Authentication",
      "REST APIs",
    ],
  },
  {
    title: "Product workflow",
    items: [
      "UI testing",
      "Component thinking",
      "Postman",
      "DBeaver",
      "Debugging",
      "Iteration",
    ],
  },
];

const technologies = [
  { title: "HTML", image: html },
  { title: "CSS", image: css },
  { title: "JavaScript", image: javascript },
  { title: "React", image: react },
  { title: "Tailwind CSS", image: tailwind },
  { title: "Node.js", image: node },
  { title: "Next.js", image: nextjs },
  { title: "Firebase", image: firebase },
  { title: "Express", image: express },
];

const additionalTools = [
  "React Native",
  "AWS",
  "Postman",
  "Expo",
  "PostgreSQL",
  "DBeaver",
];

const Experience = () => {
  return (
    <section name="skills" className="section-frame">
      <div className="grid gap-14 lg:grid-cols-[0.82fr_1.18fr] lg:gap-20">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7 }}
        >
          <p className="section-kicker">Skills</p>
          <h2 className="section-title mt-6 max-w-xl">
            A stack shaped around shipping clean, responsive product UI.
          </h2>
          <p className="section-copy mt-8">
            I work best when the frontend feels intentional and the underlying
            implementation stays maintainable. These are the tools and areas I
            reach for most often.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.75, delay: 0.08 }}
          className="grid gap-8"
        >
          <div className="grid gap-8 md:grid-cols-3">
            {capabilityGroups.map((group) => (
              <div key={group.title} className="border-t border-white/10 pt-5">
                <h3 className="font-['Sora'] text-lg text-slate-100">
                  {group.title}
                </h3>
                <div className="mt-5 flex flex-wrap gap-3">
                  {group.items.map((item) => (
                    <span
                      key={item}
                      className="skill-chip rounded-full px-4 py-2 text-xs uppercase tracking-[0.18em]"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {technologies.map((technology) => (
              <div
                key={technology.title}
                className="flex items-center gap-4 rounded-[1.5rem] border border-white/10 px-5 py-4"
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/5">
                  <img
                    src={technology.image}
                    alt={technology.title}
                    className="h-9 w-9 object-contain"
                  />
                </div>
                <p className="text-sm font-medium uppercase tracking-[0.18em] text-slate-200">
                  {technology.title}
                </p>
              </div>
            ))}
          </div>

          <div className="border-t border-white/10 pt-6">
            <h3 className="font-['Sora'] text-lg text-slate-100">
              Also working with
            </h3>
            <div className="mt-5 flex flex-wrap gap-3">
              {additionalTools.map((tool) => (
                <span
                  key={tool}
                  className="skill-chip rounded-full px-4 py-2 text-xs uppercase tracking-[0.18em]"
                >
                  {tool}
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
